// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3OnMf","filesListContainer":"PosDisputesFiles_filesListContainer__1mYCf","filesButton":"PosDisputesFiles_filesButton__33JnE"};